export default class Lang {
	/**
	 * Instantiates a Lang with default values
	 *
	 * @class
	 * @param {any} lang
	 */
	constructor(lang = undefined) {
		/**
		 * "is_a" class identifier
		 *
		 * @type {import('@knitiv/api-client-javascript').KNode | undefined}
		 */
		this.isa = lang?.isa;

		/**
		 * K identifier
		 *
		 * @type {import('@knitiv/api-client-javascript').KNode | undefined}
		 */
		this.kid = lang?.kid;

		/**
		 * Language name
		 *
		 * @type {string | undefined}
		 */
		this.name = lang?.name;
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} langKid
	 */
	setLang(langKid) {
		this.isa = 'K_NODE;LANGUE';
		this.kid = langKid;
	}

	/**
	 * Sets the Lang instance to "universal" - K_NODE;UNIVERSEL language
	 */
	setUniversel() {
		this.isa = 'K_NODE;SYS_CLASSE';
		this.kid = 'K_NODE;UNIVERSEL';
		this.name = 'Universel';
	}
}
